import { ReferenceType } from '../domain/types';

export const referenceTypeLabels: Record<ReferenceType, string> = {
  [ReferenceType.AGENT]: 'Agente',
  [ReferenceType.AGENCY]: 'Agenzia',
  [ReferenceType.CONTACT]: 'Contatto',
  [ReferenceType.INTENT]: 'Interesse',
  [ReferenceType.JOB_APPLICATION]: 'Candidatura',
  [ReferenceType.LEAD]: 'Lead',
  [ReferenceType.PROPERTY]: 'Immobile',
  [ReferenceType.PROSPECT]: 'Valutazione',
  [ReferenceType.OFFER]: 'Proposta',
  [ReferenceType.RUMOR]: 'Notizia',
  [ReferenceType.SEARCH_CRITERIA]: 'Ricerca',
  [ReferenceType.TASK]: 'Attività',
  [ReferenceType.INVOICE]: 'Pagamento',
  [ReferenceType.COMPANY]: 'Persona giuridica',
};
